import { atom } from "jotai";

import { UpdateGuestRoundInput } from "../../../../../components/TransferOwnership/hooks/__generated__/useUpdateSingleSlotBookingMutation.graphql";
import { currentBookingAtom } from "../../../../stores";

export const updatedGuestRoundsAtom = atom<UpdateGuestRoundInput[] | null>(
  (get) => {
    const currentBooking = get(currentBookingAtom);
    if (!currentBooking) return null;
    const rounds = currentBooking.rounds;
    const guestRounds = rounds?.filter(
      (r) =>
        r.player?.clientType === "guest" ||
        r.player?.clientType === "unknownGuest"
    );
    const input: UpdateGuestRoundInput[] = guestRounds?.map((r) => ({
      index: r.index,
      id: r.serverId,
      playerId: r.player?.id || null,
      courseLayoutId: r.type === "Golf" ? r.courseLayout?.id : null,
      transportationTypeId: r.type === "Golf" ? r.transportationType?.id : null,
    }));
    return input;
  }
);
